import { forwardRef, type Ref, type SVGProps } from "react";
const IconBeautySpaOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 6h2a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2v2a1 1 0 0 0-1 1v1q0 .044.004.086a2 2 0 0 0-1.417 1.83l-.543 13.042A1 1 0 0 0 7.043 26h5.915a1 1 0 0 0 1-1.042l-.544-13.041a2 2 0 0 0-1.417-1.831q.004-.042.004-.086V9a1 1 0 0 0-1-1zm-2.414 6-.5 12h3.83l-.5-12zM18 9.535V7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2.535c1.196.692 2 1.984 2 3.465v12a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V13c0-1.48.805-2.773 2-3.465M20 9V8h2v1zm0 2a2 2 0 0 0-2 2v11h6V13a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconBeautySpaOutlineSVG);
ForwardRef.displayName = "IconBeautySpaOutline";
export { ForwardRef as IconBeautySpaOutline };
